export function parseDispatchSavesExportPayload(rawPayload) {
  if (!rawPayload || typeof rawPayload !== "object") {
    throw new Error("Le fichier de sauvegardes dispatch doit contenir un objet JSON.");
  }

  if (rawPayload.export_kind === "data_manager_dispatch_saves" && Array.isArray(rawPayload.items)) {
    return rawPayload.items.filter(Boolean);
  }

  if (rawPayload.snapshot && rawPayload.planning_state) {
    return [{
      dispatch_date: rawPayload.dispatch_date || null,
      source_snapshot_id: rawPayload.metadata?.saved_snapshot_id || null,
      payload: rawPayload,
    }];
  }

  throw new Error("Aucune sauvegarde dispatch importable n'a été trouvée dans le fichier.");
}

export async function readDispatchSavesExportFile(file) {
  const fileText = await file.text();
  let rawPayload;

  try {
    rawPayload = JSON.parse(fileText);
  } catch {
    throw new Error("Le fichier de sauvegardes dispatch n'est pas un JSON valide.");
  }

  return parseDispatchSavesExportPayload(rawPayload);
}

const DISPATCH_SAVE_IMPORT_DAY_FORMATTER = new Intl.DateTimeFormat("fr-CA", {
  day: "numeric",
  month: "long",
  year: "numeric",
});

function parseDispatchSaveImportDate(value) {
  const rawValue = typeof value === "string" ? value.trim() : "";
  if (!rawValue) {
    return null;
  }

  const isoDateMatch = /^(\d{4})-(\d{2})-(\d{2})/.exec(rawValue);
  if (isoDateMatch) {
    const parsedDate = new Date(
      Number(isoDateMatch[1]),
      Number(isoDateMatch[2]) - 1,
      Number(isoDateMatch[3]),
      12,
      0,
      0,
      0,
    );
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
  }

  const parsedDate = new Date(rawValue);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
}

export function formatDispatchSaveImportDate(value) {
  const parsedDate = parseDispatchSaveImportDate(value);
  if (!parsedDate) {
    return typeof value === "string" ? value.trim() : "";
  }

  return DISPATCH_SAVE_IMPORT_DAY_FORMATTER.format(parsedDate);
}

export function formatDispatchSaveImportDateList(dispatchDates = []) {
  const labels = [...new Set(
    dispatchDates
      .map((dispatchDate) => formatDispatchSaveImportDate(dispatchDate))
      .filter(Boolean),
  )];

  if (labels.length === 0) {
    return "";
  }

  if (labels.length === 1) {
    return labels[0];
  }

  if (labels.length === 2) {
    return `${labels[0]} et ${labels[1]}`;
  }

  return `${labels.slice(0, -1).join(", ")} et ${labels[labels.length - 1]}`;
}

export function formatDispatchSaveImportTimestamp(value) {
  const rawValue = typeof value === "string" ? value.trim() : "";
  if (!rawValue) {
    return "";
  }

  const parsedDate = new Date(rawValue);
  if (Number.isNaN(parsedDate.getTime())) {
    return rawValue;
  }

  return new Intl.DateTimeFormat("fr-CA", {
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(parsedDate);
}
